module.exports = __webpack_public_path__ + "img/car-style_comfort.bf044cd5.svg";